import { StaticPageLayout } from '../components/layout/StaticPageLayout'

const INSTALL_IOS_MARKDOWN = `PantryIO works as a Progressive Web App on iPhone — no App Store needed. Once installed, it behaves like a native app: home screen icon, full-screen mode, push notifications, and offline access.

## How to install (15 seconds)

**Step 1.** Open pantryioapp.com in **Safari** (this only works in Safari, not Chrome).

**Step 2.** Tap the **Share button** at the bottom of the screen — the square icon with an arrow pointing up.

**Step 3.** Scroll down in the share menu and tap **"Add to Home Screen"**.

**Step 4.** Tap **"Add"** in the top-right corner.

That's it. PantryIO is now on your home screen. Tap to launch.

## What works

- Full app experience, identical to a native app
- Receipt scanning, recipe browsing, shopping lists
- Push notifications for expiry alerts (after enabling in Settings)
- Household sync, Stripe checkout, all features

## Why isn't there an iPhone App Store version yet?

We're focused on getting PantryIO into your hands as fast as possible. A native iOS app is coming, but the web app is fully functional in the meantime — and you'll never lose any data when we transition. Your account works the same across web, home-screen install, and future native versions.

Questions? Email support@pantryioapp.com.
`

export default function InstallIos() {
  return (
    <StaticPageLayout
      documentTitle="Install PantryIO on iPhone"
      heading={<>Install PantryIO on <em className="italic">iPhone</em></>}
      markdown={INSTALL_IOS_MARKDOWN}
    />
  )
}
